import $ from 'jquery';

export const apiCall = function(endpoint, method, payload) {
  let csrfToken =
    document.querySelector('meta[name="csrf-token"]').content || {};

  return $.ajax({
    url: endpoint,
    method: method,
    data: payload,
    contentType: 'application/json',
    headers: {
      'X-CSRF-Token': csrfToken,
    },
  });
};



// WEBPACK FOOTER //
// ./app/javascript/apps/application/api-call.js